<template>
  <section class="public-page h5--page">
    <!-- <pcTitle v-if="isPC" @dispatchUserName="receiveName" @seeName="seeName"></pcTitle> -->
    <div class="search-main" v-show="showQueXZ">
      <!-- <div class="search-tab">
        <el-tabs v-model="componentName">
          <el-tab-pane label="文件" name="file"></el-tab-pane>
          <el-tab-pane label="报告" name="report"></el-tab-pane>
          <el-tab-pane label="术语问答" name="ask"></el-tab-pane>
          <el-tab-pane label="共享资料" name="other"></el-tab-pane>
        </el-tabs>
      </div> -->
      <div class="search-list">
        <!-- <component :is="componentName" @itemClick="openPDF" :searchQObj="childSearchQ"></component> -->
        <file :showComponent="componentName" @itemClick="openPDF" :searchQObj="childSearchQ"></file>
        <report :showComponent="componentName" @itemClick="openPDF" :searchQObj="childSearchQ"></report>
        <ask :showComponent="componentName" @itemClick="openPDF" :searchQObj="childSearchQ"></ask>
        <other :showComponent="componentName" @itemClick="openPDF" :searchQObj="childSearchQ"></other>
      </div>
    </div>
    <!-- <div>
      <div class="index-bottom-1">
        <div class="title-link">
          <div class="link-line">
            <span class="link-title">
              国家生态环境网站：
            </span>
            <a href="http://www.mee.gov.cn/" target="_blank">生态环境部</a>
          </div>
          <div class="link-line">
            <span class="link-title">
              省级生态环境网站：
            </span>
            <a href="http://sthjj.beijing.gov.cn/" target="_blank">北京</a>
            <a href="http://sthj.tj.gov.cn/" target="_blank">天津</a>
            <a href="https://sthj.sh.gov.cn/" target="_blank">上海</a>
            <a href="http://sthjj.cq.gov.cn/" target="_blank">重庆</a>
            <a href="http://hbepb.hebei.gov.cn/" target="_blank">河北</a>
            <a href="https://sthjt.shanxi.gov.cn/" target="_blank">山西</a>
            <a href="http://sthj.ln.gov.cn/" target="_blank">辽宁</a>
            <a href="http://sthjt.jl.gov.cn/" target="_blank">吉林</a>
            <a href="http://www.hljdep.gov.cn/" target="_blank">黑龙江</a>
            <a href="http://hbt.jiangsu.gov.cn/" target="_blank">江苏</a>
            <a href="http://sthjt.zj.gov.cn/" target="_blank">浙江</a>
            <a href="http://sthjt.ah.gov.cn/" target="_blank">安徽</a>
            <a href="http://sthjt.fujian.gov.cn/" target="_blank">福建</a>
            <a href="http://sthjt.jiangxi.gov.cn/" target="_blank">江西</a>
            <a href="http://sthj.shandong.gov.cn/" target="_blank">山东</a>
            <a href="http://sthjt.henan.gov.cn/" target="_blank">河南</a>
            <a href="http://sthjt.hubei.gov.cn/" target="_blank">湖北</a>
            <a href="http://sthjt.hunan.gov.cn/" target="_blank">湖南</a>
            <a href="http://gdee.gd.gov.cn/" target="_blank">广东</a>
            <a href="http://hnsthb.hainan.gov.cn/" target="_blank">海南</a>
            <a href="http://sthjt.sc.gov.cn/" target="_blank">四川</a>
            <a href="http://sthj.guizhou.gov.cn/" target="_blank">贵州</a>
            <a href="http://sthjt.yn.gov.cn/index.html" target="_blank">云南</a>
            <a href="http://sthjt.shaanxi.gov.cn/" target="_blank">陕西</a>
            <a href="http://sthj.gansu.gov.cn/" target="_blank">甘肃</a>
            <a href="http://sthjt.qinghai.gov.cn/" target="_blank">青海</a>
            <a href="http://ee.xizang.gov.cn/sysweb/portal/index.htl" target="_blank">西藏自治区</a>
            <a href="http://sthjt.nmg.gov.cn/" target="_blank">内蒙古自治区</a>
            <a href="http://sthjt.gxzf.gov.cn/" target="_blank">广西壮族自治区</a>
            <a href="http://sthjt.nx.gov.cn/" target="_blank">宁夏回族自治区</a>
            <a href="http://sthjt.xinjiang.gov.cn/" target="_blank">新疆维吾尔自治区</a>
            <a href="http://hbj.xjbt.gov.cn/" target="_blank">新疆生产建设兵团</a>
          </div>
          <div class="link-line">
            <span class="link-title">
              友情链接：
            </span>
            <a href="http://permit.mee.gov.cn/permitExt/defaults/default-index!getInformation.action" target="_blank">排污许可平台</a>
            <a href="http://114.251.10.92:8080/XYPT/" target="_blank">环评信用平台</a>
            <a href="https://cepc.lem.org.cn/#/login" target="_blank">自主验收平台</a>
            <a href="http://www.soilinfo.cn/map/index.aspx" target="_blank">土壤信息平台</a>
            <a href="http://www.ceett.org.cn/huanbao/infomation/xscx.html" target="_blank">环境工程服务</a>
            <a href="http://cloud.lem.org.cn/" target="_blank">环境质量模拟</a>
          </div>
          <div class="link-line-1">
            <a href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备15023665号-3</a>
            |
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014179">浙公网安备 33011002014179号</a>
            | 电话：0571-82763607
            <span style="color:#551A8B;padding:0px 0px 0px 400px;">总访问人次:{{nameNum}}</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="searchdiv">
      <!-- <el-input class="search-input" :clearable="true" size="small" v-model="searchQ" placeholder="输入标题或作者进行搜索" @blur="handleCommonItemClick(searchQ)" @clear="handleCommonItemClick(searchQ)">
        <el-button slot="append" icon="el-icon-search" @click="handleCommonItemClick(searchQ)"></el-button>
      </el-input> -->
      <!-- <span v-if="ashKetchup === true" class="do-public1" @click="openQue">小智问答</span> -->
      <!-- <div class="search-tips">
        <searchTips :currentDocList="[]" :loadingTip="false" :noMore="false" :afterInput="true"></searchTips><br>
      </div> -->
      <!-- <span class="do-public1" v-if="Number(isShow) == 1" @click="showCompanyOption()">{{ optBtnName }}</span> -->
      <span class="do-public1" @click="showCompanyOption()">{{ optBtnName }}</span>
    </div>
    <nut-dialog
      class="nut-dialog-c"
      :closeOnClickModal="false"
      @close="fileFlagA = false"
      v-if="fileFlagA"
      :visible="fileFlagA"
      title="检查初审"
      :noFooter="true">
      <upFileA
        ref="uploadRef"
        :btnName="'上传'"
        :uploadMethod="'cdAshKetchupOneUpload'"
        :acceptList="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf'"
        :extaParam="extaParamA"
        :fileSize="100"
        @uploadSuccess="handleSuccessA"
        @beforeUpload="checkUploadA"
        @closeIF="closeIFA">
      </upFileA>
    </nut-dialog>
    <nut-dialog
      class="nut-dialog-a"
      :closeOnClickModal="false"
      @close="fileFlag = false"
      v-if="fileFlag"
      :visible="fileFlag"
      :title="optBtnName"
      :noFooter="true">
      <upFile
        ref="uploadRef"
        :btnName="'上传'"
        :uploadMethod="'cdAshKetchupOneUpload'"
        :acceptList="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf'"
        :extaParam="extaParam"
        :fileSize="100"
        @uploadSuccess="handleSuccess"
        @beforeUpload="checkUpload"
        @closeIF="closeIF">
      </upFile>
    </nut-dialog>
    <nut-dialog
      class="nut-dialog-b"
      @close="payTipsFlag = false"
      :closeOnClickModal="false"
      v-if="payTipsFlag"
      :visible="payTipsFlag"
      title="提示"
      :noFooter="false"
      :onOkBtn="onOkBtn"
      :onCancelBtn="onCancelBtn"
      cancelBtnTxt="关闭">
      <div align="center">
        <span style="font-size: 16px;">{{ payTips }}</span>
      </div>
    </nut-dialog>
    <splitNewFiles></splitNewFiles>
    <pcTitleLogOnly ref="pTLO"></pcTitleLogOnly>
    <fileRank></fileRank>
    <accountCom :showLogin.sync="loginDialogShow" @dispatchUserName="receiveName"></accountCom>
    <div class="search-chat-detail-auto" v-if="showChatAuto">
      <div>
        <div>
          <div v-for="(item, index) in dataList" :key="index">
            <div align="left" v-if="item.type === 0" style="height: 36px; max-width: 80%;">
              <img style="margin-left: 8px;" src="../assets/icon.png" width="24px">
              <span class="message-item">{{ item.text }}</span>
            </div>
            <!-- <div v-if="item.type === 0 && item.userAns === true" align="right">
              <span style="background: #95ec69;border: 1px solid #efefef;display:inline-block;border-radius: 10px;padding: 6px;font-size: 16px;max-width: 80%;text-align: left">{{ item.userAnswer }}</span><img :src="picture" width="20px">
            </div> -->
            <div v-if="item.type === 1">
              <div align="left">
                <img style="margin-left: 8px;" src="../assets/icon.png" width="24px"><span style="display:inline-block;border-radius: 10px;padding: 6px;font-size: 16px;">{{ item.text }}</span>
              </div>
              <div align="left" style="border: 1px solid #efefef;border-radius: 10px;padding: 6px;width: 65%;margin: 10px 0 0 0;text-align: left">
                <div v-for="(itemA, indexA) in item.list" :key="indexA" style="display: inline-block;">
                  <span @click="openShow(itemA, item)" style="font-size: 16px;margin:0 10px 0 0;color: #409EFF;"><i class="el-icon-info"></i>{{itemA.question}}</span>
                </div>
              </div>
              <div v-if="item.userAns === true" align="right">
                <span style="background: #95ec69;border: 1px solid #efefef;display:inline-block;border-radius: 10px;padding: 6px;font-size: 16px;max-width: 80%;text-align: left">{{ item.userAnswer }}</span><img :src="picture" width="20px">
              </div>
            </div>
            <div align="left" v-if="item.type === 2">
              <img style="margin-left: 8px;" src="../assets/icon.png" width="24px"><span style="display:inline-block;border-radius: 10px;padding: 6px;font-size: 16px;">{{ item.text }}</span>
              <div style="border: 1px solid #efefef;border-radius: 10px;padding: 6px;width: 60%;margin: 10px 0 0 0;text-align: left">
                <div v-for="(itemA, indexA) in item.list" :key="indexA" style="display: inline-block;">
                  <p style="font-size: 16px;margin:0 10px 0 0;color: #409EFF;">{{itemA.question}}</p>
                </div>
              </div>
              <div v-if="item.userAns === true" align="right">
                <span style="background: #95ec69;border: 1px solid #efefef;display:inline-block;border-radius: 10px;padding: 6px;font-size: 16px;max-width: 80%;text-align: left">{{ item.userAnswer }}</span><img :src="picture" width="20px">
              </div>
            </div>
            <div align="left" v-if="item.type === 3">
              <img style="margin-left: 8px;" src="../assets/icon.png" width="24px"><span style="display:inline-block;border-radius: 10px;padding: 6px;font-size: 16px;">{{ item.text }}</span>
              <div style="border: 1px solid #efefef;border-radius: 10px;padding: 6px;width: 60%;margin: 10px 0 0 0;text-align: left">
                <div v-for="(itemA, indexA) in item.list" :key="indexA" style="display: inline-block;">
                  <img src="https://image.qsyhbgj.com/img-attach.png" width="20px"><span @click="openOther(itemA)" style="font-size: 16px;margin:0 10px 0 0;color: #409EFF;">{{itemA.question}}</span>
                </div>
              </div>
              <div v-if="item.userAns === true" align="right">
                <span style="background: #95ec69;border: 1px solid #efefef;display:inline-block;border-radius: 10px;padding: 6px;font-size: 16px;max-width: 80%;text-align: left">{{ item.userAnswer }}</span><img :src="picture" width="20px">
              </div>
            </div>
            <div v-if="item.type === 4" style="margin: 10px 0 0 0;">
              <div align="left">
                <img style="margin-left: 8px;" src="../assets/icon.png" width="24px">
                <template style="border-radius: 10px;padding: 6px;font-size:16px">
                  <span v-for="(itemA, indexA) in item.list" :key="indexA" style="font-size:16px">
                    <span v-if="Number(itemA.category) === 1">{{ itemA.question }}</span>
                    <span style="color: #409EFF;" v-else @click="openShow(itemA, item)"><u>{{ itemA.question }}</u></span>
                  </span>
                </template>
              </div>
              <div v-if="item.userAns === true" align="right">
                <span style="background: #95ec69;border: 1px solid #efefef;display:inline-block;border-radius: 10px;padding: 6px;font-size: 16px;max-width: 80%;text-align: left">{{ item.userAnswer }}</span><img :src="picture" width="20px">
              </div>
            </div>
            <div align="left" v-if="item.type === 5">
              <img style="margin-left: 8px;" src="../assets/icon.png" width="24px">
              <div style="border: 1px solid #efefef;border-radius: 10px;padding: 6px;width: 60%;text-align: left">
                <span v-for="(itemT, indexT) in item.text.split('\\n')" :key="indexT">{{ itemT }}<br></span>
                <div v-for="(itemA, indexA) in item.list" :key="indexA">
                  <p v-for="(itemTQ, indexTQ) in itemA.question.split('\n')" :key="indexTQ" style="font-size: 16px;margin:0 10px 0 0;">{{itemTQ}}</p>
                  <div v-for="(itemA1, indexA) in itemA.list1" :key="indexA" style="display: inline-block;">
                    <img src="https://image.qsyhbgj.com/img-attach.png" width="20px"><span @click="openSrcFile(itemA1)" style="font-size: 16px;margin:0 10px 0 0;color: #409EFF;">{{itemA1.title}}</span>
                  </div>
                </div>
                <p>{{ item.text1 }}</p>
              </div>
              <div v-if="item.userAns === true" align="right">
                <span style="background: #95ec69;border: 1px solid #efefef;display:inline-block;border-radius: 10px;padding: 6px;font-size: 16px;max-width: 80%;text-align: left">{{ item.userAnswer }}</span><img :src="picture" width="20px">
              </div>
            </div>
            <!-- 统一 -->
            <div align="left" v-if="item.list0 && item.list0.length">
              <img style="margin-left: 8px;" src="../assets/icon.png" width="24px">
              <div class="message-item">
                <p>{{ item.text }}</p>
                <div v-for="(par, indexP) in item.list0" :key="indexP">
                  <template v-if="par.type === 1">
                    <div class="message-option" @click="openShow(itemA, item)"
                      v-for="(itemA, indexA) in par.list" :key="indexA">
                      <span class="uni-icon" style="font-size: 14px;">&#xe504;</span>
                      <!-- <p v-for="(itemTQ, indexTQ) in itemA.question.split('\n')" :key="indexTQ" style="font-size: 16px;margin:0 10px 0 0;">{{itemTQ}}</p> -->
                      {{ itemA.question }}
                    </div>
                    <!-- <div class="message-option-null" v-if="!par.list.length">
                      > 当前分类暂无数据
                    </div> -->
                  </template>
                  <template v-if="par.type === 2">
                    <div class="message-text"
                      v-for="(itemA, indexA) in par.list" :key="indexA">
                      <!-- {{ itemA.text }} -->
                      <!-- -->
                      <!-- <span v-for="(itemTQ, indexTQ) in itemA.question.split('\n')" :key="indexTQ" style="font-size: 16px;margin:0 10px 0 0;">{{itemTQ}}</span> -->
                      <template v-if="itemA.question.indexOf('thinkStart') >= 0 && itemA.question.indexOf('thinkEnd') >= 0">
                        <span style="color: gray; font-size: 12px;"><span v-for="(itemTQ, indexTQ) in itemA.question.split('thinkStart')[1].split('thinkEnd')[0].split('\n')" :key="indexTQ" style="font-size: 16px;">{{itemTQ}}<br v-if="indexTQ < itemA.question.split('thinkStart')[1].split('thinkEnd')[0].split('\n').length - 1"></span></span><span v-for="(bItem, bIndex) in itemA.question.split('thinkStart')[1].split('thinkEnd')[1].split('**')" :key="bIndex"
                          :style="bIndex % 2 === 1 ? 'font-weight: bold;' : ''"><span v-for="(itemTQ, indexTQ) in bItem.split('\n')" :key="indexTQ" style="font-size: 16px;">{{itemTQ}}<br v-if="indexTQ < bItem.split('\n').length - 1"></span></span>
                      </template>
                      <template v-else>
                        <span v-for="(bItem, bIndex) in itemA.question.split('**')" :key="bIndex"
                          :style="bIndex % 2 === 1 ? 'font-weight: bold;' : ''"><span v-for="(itemTQ, indexTQ) in bItem.split('\n')" :key="indexTQ" style="font-size: 16px;">{{itemTQ}}<br v-if="indexTQ < bItem.split('\n').length - 1"></span></span>
                      </template>
                      <!-- -->
                      <!-- {{ itemA.question }} -->
                      <!-- <template v-if="itemA.list1 && itemA.list1.length">
                        <div class="message-file" @click="srcFileClick(item1)"
                          v-for="(item1, indexA) in itemA.list1" :key="indexA">
                          {{ item1.title }}
                        </div>
                      </template> -->
                    </div>
                  </template>
                  <!-- <div v-if="item.type === 'answer'" align="right"> -->
                  <template v-if="par.type === 3">
                    <div class="message-file" @click="openOther(itemA)"
                      v-for="(itemA, indexA) in par.list" :key="indexA">
                      {{ itemA.title }}
                    </div>
                  </template>
                  <template v-if="par.type === 4">
                    <template v-for="(itemA, indexA) in par.list">
                      <span :key="indexA" v-if="itemA.category === '1'" class="message-text">
                        <!-- <p v-for="(itemTQ, indexTQ) in itemA.question.split('\n')" :key="indexTQ" style="font-size: 16px;margin:0 10px 0 0;">{{itemTQ}}</p> -->
                        <!-- {{itemA.question}} -->
                        <span v-for="(bItem, bIndex) in itemA.question.split('**')" :key="bIndex"
                          :style="bIndex % 2 === 1 ? 'font-weight: bold;' : ''"><span v-for="(itemTQ, indexTQ) in bItem.split('\\n')" :key="indexTQ" style="font-size: 16px;">{{itemTQ}}<br v-if="indexTQ < bItem.split('\\n').length - 1"></span></span>
                      </span>
                      <!-- <span v-if="itemA.category === '2'" class="message-inline uni-icon" @click="optionClick(itemA)" style="font-size: 14px;">&#xe504;</span> -->
                      <span :key="indexA" v-if="itemA.category === '2'" class="message-inline" @click="openShow(itemA, item)"><u>
                        <!-- <p v-for="(itemTQ, indexTQ) in itemA.question.split('\n')" :key="indexTQ" style="font-size: 16px;margin:0 10px 0 0;">{{itemTQ}}</p> -->
                        {{itemA.question}}
                      </u></span>
                      <span :key="indexA" v-if="itemA.category === '3' && item.fileNum > 1" class="message-inline" @click="openShow(itemA, item)"><u>{{!item.isShowMoreFile ? itemA.question : itemA.question1}}</u></span>
                    </template>
                  </template>
                  <template v-if="par.type === 5">
                    <div :class="{
                      'message-srcFile': indexA === 0 || (indexA !== 0 && item.isShowMoreFile),
                      'message-srcFile-hide': indexA !== 0 && !item.isShowMoreFile
                    }"
                      @click="openSrcFile(itemA)"
                      v-for="(itemA, indexA) in par.list" :key="indexA">
                      <template v-if="indexA === 0 || item.isShowMoreFile">
                        <!-- <template v-if="item.isShowMoreFile">{{ indexA+1 }}.</template> -->
                        {{ itemA.title }}
                      </template>
                    </div>
                  </template>
                </div>
                <p>{{ item.text1 }}</p>
              </div>
            </div>
            <div v-if="item.type === 'answer'" align="right">
              <span style="background: #95ec69;border: 1px solid #efefef;display:inline-block;border-radius: 12px 0 12px 12px;padding: 6px 12px 8px;font-size: 16px;max-width: 80%;text-align: left; margin-right: 8px;">{{ item.userAnswer }}</span><img :src="picture" width="20px">
            </div>
            <div align="left" v-if="showLoadingSteps && index === dataList.length - 1">
              <img style="margin-left: 8px;" src="../assets/icon.png" width="24px">
              <div class="message-item">
                <p>{{ loadingTips }}</p>
                <progress :value="loadingProgress" max="100"></progress>
                <!-- <progress :value="loadingProgress" max="100"></progress>&nbsp;{{ loadingProgress }}% -->
              </div>
            </div>
            <!-- /统一 -->
            <div class="input-box">
              <div v-if="!showLoadingSteps && index === dataList.length - 1" class="input-box-line">
                <div class="input-box-inner input-box-inner-left">
                </div>
                <div class="input-box-inner input-box-inner-right">
                  <el-input class="input-textarea" type="textarea" :rows="2" placeholder="请输入您想要提问的内容" v-model="inputValA" style="width: 80%; height: 80px;"></el-input>
                  <div class="btn-line">
                    <div class="line-inner line-left">
                      <div class="btn"
                        :class="item.active ? 'btn-active' : ''"
                        v-for="(item, index) in switchList" :key="index" @click="changeSwitch(item, index)">
                        {{ item.label }}
                      </div>
                      <!-- <select v-model="fileCategory">
                        <option v-for="(item, index) in fileCategoryList" :key="index" :label="item" :value="item"></option>
                      </select>
                      <select v-model="activeModelItem.value" @change="changePayTips">
                        <option v-for="(item, index) in modelList" :key="index" :label="item.label" :value="item.value"></option>
                      </select> -->
                      <select v-if="listTen.length > 1" size="medium" v-model="aiName">
                        <option v-for="(item, index) in listTen" :key="index" :label="item" :value="item"></option>
                      </select>
                    </div>
                    <div class="line-inner line-right">
                      <!-- <el-button slot="append" v-if="!inputValA" :disabled="inputValA" @click="openShowA(inputValA, item)">发送</el-button> -->
                      <!-- <el-button slot="append" v-else type="primary" @click="openShowA(inputValA, item)">发送</el-button> -->
                      <el-button class="btn" circle icon="el-icon-paperclip" @click="showCompanyOptionA(inputValA, item)"></el-button>
                      <el-button class="btn submit" circle icon="el-icon-top" :type="inputValA ? 'primary' : ''" @click="openShowA(inputValA, item)"></el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="bottomId"></div>
        </div>
      </div>
      <!-- <div v-if="showFourList" style="margin: 10px 0 0 0;">
        <IndustriesClassificationA :inputValA="inputValA"></IndustriesClassificationA>
      </div>
      <div v-if="showFourListA" style="margin: 10px 0 0 0;height: 600px;">
        <FamousPageA :inputValA="inputValA"></FamousPageA>
      </div>
      <div v-if="showFourListB" style="margin: 10px 0 0 0;">
        <file-cardA :cardData="item" v-for="(item, index) in fileList" :key="index"></file-cardA>
      </div> -->
      <!-- <div class="bottom-pagination">
        <el-pagination
          v-if="showFourListB"
          hide-on-single-page
          small
          background
          layout="prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="totalNumber">
        </el-pagination>
      </div> -->
      <!-- <div v-if="showFourListSe" style="margin: 10px 0 0 0;">
        <secPolPopul :inputValA="inputValA"></secPolPopul>
      </div>
      <div v-if="showFourListDQ" style="margin: 10px 0 0 0;">
        <deductPointsQue :inputValA="inputValA"></deductPointsQue>
      </div>
      <div v-if="showFourListJC" style="margin: 10px 0 0 0;">
        <quaSearchA :inputValA="inputValA"></quaSearchA>
      </div> -->
      <!-- <div v-if="showAllFileList" :style="ansNew === 'wjzl' ? 'height: 1000px;overflow-y: auto;margin: 10px 0 0 0;' : 'height: 200px;overflow-y: auto;margin: 10px 0 0 0;'">
        <el-tabs v-model="componentName1">
          <el-tab-pane v-if="showModuleConfig[0] > 0" label="文件" name="file"></el-tab-pane>
          <el-tab-pane v-if="showModuleConfig[1] > 0" label="报告" name="report"></el-tab-pane>
          <el-tab-pane v-if="showModuleConfig[2] > 0" label="术语问答" name="ask"></el-tab-pane>
          <el-tab-pane v-if="showModuleConfig[3] > 0" label="共享资料" name="other"></el-tab-pane>
        </el-tabs>
        <el-button v-if="ansNew == 'wjzl'" type="primary" @click="openAllMore" size='mini' style='position: absolute;right:10px;margin: -44px 0 0 0'>更多</el-button>
        <fileA :showComponent="componentName1" @itemClick="openPDFA" :searchQObj="childSearchQ1"></fileA>
        <reportA :showComponent="componentName1" @itemClick="openPDFA" :searchQObj="childSearchQ1"></reportA>
        <askA :srcType="srcType" :showComponent="componentName1" @itemClick="openPDFA" :searchQObj="childSearchQ1"></askA>
        <otherA :showComponent="componentName1" @itemClick="openPDFA" :searchQObj="childSearchQ1"></otherA>
      </div> -->
      <!-- <el-dialog
        append-to-body
        center
        width="40%"
        :close-on-click-modal="false"
        :visible.sync="showFileAllList"
        v-if="showFileAllList"
        title="更多文件资料">
        <div style="height: 1000px;overflow-y: auto">
          <el-tabs v-model="componentName2">
            <el-tab-pane v-if="showModuleConfig[0] > 0" label="文件" name="file"></el-tab-pane>
            <el-tab-pane v-if="showModuleConfig[1] > 0" label="报告" name="report"></el-tab-pane>
            <el-tab-pane v-if="showModuleConfig[2] > 0" label="术语问答" name="ask"></el-tab-pane>
            <el-tab-pane v-if="showModuleConfig[3] > 0" label="共享资料" name="other"></el-tab-pane>
          </el-tabs>
          <fileB :showComponent="componentName2" @itemClick="openPDFA" :searchQObj="childSearchQ2"></fileB>
          <reportB :showComponent="componentName2" @itemClick="openPDFA" :searchQObj="childSearchQ2"></reportB>
          <askB :srcType="srcType" :showComponent="componentName2" @itemClick="openPDFA" :searchQObj="childSearchQ2"></askB>
          <otherB :showComponent="componentName2" @itemClick="openPDFA" :searchQObj="childSearchQ2"></otherB>
        </div>
      </el-dialog> -->
    </div>
    <div class="search-main" v-if="showAllFileList">
      <div class="search-tab">
        <el-tabs v-model="componentName">
          <el-tab-pane label="文件" name="file"></el-tab-pane>
          <el-tab-pane label="报告" name="report"></el-tab-pane>
          <el-tab-pane label="术语问答" name="ask"></el-tab-pane>
          <el-tab-pane label="共享资料" name="other"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="search-list">
        <file :showComponent="componentName" @itemClick="openPDF" :searchQObj="childSearchQ"></file>
        <report :showComponent="componentName" @itemClick="openPDF" :searchQObj="childSearchQ"></report>
        <ask :showComponent="componentName" @itemClick="openPDF" :searchQObj="childSearchQ"></ask>
        <other :showComponent="componentName" @itemClick="openPDF" :searchQObj="childSearchQ"></other>
      </div>
    </div>
  </section>
</template>

<script>
import accountCom from '@/components/account/index'
// import banner from '@/components/public/banner'
// import pcTitle from '@/components/pcTitle'
import splitNewFiles from '@/components/public/splitNewFiles'
import fileRank from '@/components/public/fileRank'
import api from '../../api/index'
import xss from 'xss'
import detect from '@/util/detect'
import File from '@/components/search/file.vue'
import Report from '@/components/search/report.vue'
import Ask from '@/components/search/ask.vue'
import Other from '@/components/search/other.vue'
// import SearchTips from '@/components/search/searchTips.vue'
import PcTitleLogOnly from '../components/pcTitle_logOnly.vue'
import upFile from '../../src/pages/upFile.vue'
import upFileA from '../../src/pages/upFileA.vue'
export default {
  data () {
    return {
      content: '',
      area: '',
      name: '',
      nameNum: '',
      publicTitle: '',
      userName: '',
      classa: '',
      time: '',
      commentList: [],
      isLoading: false,
      pageEnd: false,
      focusFlag: false,
      commentValue: '',
      avator: '',
      loginDialogShow: false,
      loginFlag: Boolean(sessionStorage.getItem('qs_token')),
      isPC: detect.isPC,
      // s
      showModuleConfig: [],
      searchObjGather: {
        file: {
          pro: '',
          sort: '0',
          searchClass: [],
          searchAreaClass: [],
          classMenuData: [],
          classAreaMenuData: []
        }
      },
      componentName: 'file',
      searchQ: '',
      childSearchQ: {},
      flexStyle: '0 0 300px',
      // 小智问答
      preciseSearch: false,
      fullTextSearch: false,
      componentName1: 'file',
      componentName2: 'file',
      childSearchQ1: {},
      childSearchQ2: {},
      percent: 0,
      searchKeyWord: '',
      optionsNew: [],
      showOneSearch: false,
      choiceList1: [],
      choiceList2: [],
      choiceList3: [],
      choiceOne: '',
      choiceTwo: '',
      choiceOneId: '',
      choiceTwoId: '',
      showTwoSearch: false,
      optionList1: [],
      optionList2: [],
      optionList3: [],
      optionOne: '',
      optionTwo: '',
      optionOneId: '',
      optionTwoId: '',
      showResult: false,
      resultList: [],
      result: '',
      showWhatSearch: false,
      showSearchInfo: false,
      showChooseInfo: false,
      number: '1',
      numberA: '0',
      numberB: '0',
      numberC: '0',
      numberD: '0',
      sureSearch: '1',
      showThreeSearch: false,
      optionThreeList1: [],
      optionThreeList2: [],
      optionThreeList3: [],
      showFourSearch: false,
      optionFourList1: [],
      optionFourList2: [],
      optionFourList3: [],
      showFiveSearch: false,
      optionFiveList1: [],
      optionFiveList2: [],
      optionFiveList3: [],
      showSixSearch: false,
      optionSixList1: [],
      optionSixList2: [],
      optionSixList3: [],
      searchOne: true,
      searchTwo: false,
      searchThree: false,
      numberMine: 1,
      numberHJ: 1,
      radio: 'search1',
      showQueList: false,
      QueList1: [{
        id: 1,
        questions: '文件资料'
      }, {
        id: 2,
        questions: '排污许可'
      }, {
        id: 3,
        questions: '环评'
      }, {
        id: 4,
        questions: '碳排放'
      }, {
        id: 5,
        questions: '验收'
      }, {
        id: 6,
        questions: '环境工程'
      }],
      // QueList2: [{
      //   id: 3,
      //   questions: '环评'
      // }, {
      //   id: 4,
      //   questions: '碳排放'
      // }],
      // QueList3: [{
      //   id: 5,
      //   questions: '验收'
      // }, {
      //   id: 6,
      //   questions: '环境工程'
      // }],
      QueList4: [{
        id: 7,
        questions: '行业类别'
      }, {
        id: 8,
        questions: '环评类别'
      }, {
        id: 9,
        questions: '排放标准'
      }, {
        id: 10,
        questions: '源强核算'
      }, {
        id: 11,
        questions: '其他问题'
      }],
      showFileAllList: false,
      showWorkTypeList: false,
      showEiaTypeList: false,
      showTwoList: false,
      showThreeList: false,
      showFourList: false,
      showFourListA: false,
      showFourListB: false,
      showFourListC: false,
      showFourListSe: false,
      showFourListDQ: false,
      showFourListJC: false,
      showAllFileList: false,
      inputValA: '',
      jimpId: 0,
      jiazai: false,
      userChoose: '',
      jiazaiA: false,
      userChooseA: '',
      text1: '',
      text2: '',
      picture: '',
      fileList: [],
      pageSize: 10,
      currentPage: 1,
      totalNumber: 10,
      dataList: [],
      answerFlag: false,
      answerOther: '',
      fileOtherList: [],
      ashKetchup: false,
      numberQA: 0,
      photoAd: '',
      searchType: '标题搜索',
      showSupportInfo: false,
      supportInfo: '',
      marketId: 0,
      marketCategory: '',
      // chat
      showChatDetails: false,
      showChatAuto: false,
      subChatId: 0,
      subUserId: 0,
      subLsMsgList: 5000,
      subSearchMsgId: 0,
      srcType: 2,
      ansNew: 'wjzl',
      showLoadingSteps: false,
      loadingStepActive: 0,
      loadingTips: '',
      loadingProgress: 0,
      showQueXZ: true,
      inputValAa: '',
      itemAa: {},
      // 新版小智问答
      payTipsFlag: false,
      payTipsType: '不提示',
      modelList: [],
      fileCategoryList: [],
      activeModelItem: {},
      fileCategory: '',
      // switchList: []
      payTips: '',
      optBtnName: '',
      isShow: 0,
      switchList: [{
        label: '环保知识库',
        value: 'typeTen',
        active: 1,
        isPay: 0,
        payTips: ''
      }, {
        label: '订阅文件',
        value: 'typeNine',
        active: 0,
        isPay: 1,
        payTips: '付费提示'
      }],
      valueIndex: 0,
      // 知识库上传文件
      fileFlag: false,
      // 知识库上传文件end
      fileFlagA: false,
      errorTips: '',
      errorObj: {
        userAns: false,
        list0: [{
          list: [{
            question: ''
          }],
          type: 2
        }],
        userAnswer: '',
        isShowMoreFile: false,
        fileNum: 0
      },
      aiName: '',
      listTen: [],
      modelName: ''
    }
  },
  computed: {
    extaParam () {
      return {
        type: 0
      }
    },
    extaParamA () {
      return {
        type: 1,
        buttonType: 1
      }
    }
  },
  created () {
    if (this.$route.query.token) {
      this.$router.replace('/h5public-detail?id=' + this.$route.query.id)
    }
    api.getUserInfo({
    }).then(res => {
      this.ashKetchup = res.data.ashKetchup
      if (res.data.ashKetchup === true) {
        this.openQue()
      }
    })
  },
  mounted () {
    this.seeName()
    api.remarks({
      type: 240
    }).then(res => {
      this.errorTips = res.data.list[0].subscribe
      // this.errorObj.list0[0].list[0].question = this.errorTips
    })
  },
  activated () {
    this.area = ''
    this.classa = ''
    this.publicTitle = ''
    this.userName = ''
    this.content = ''
    this.time = ''
    this.avator = ''
    this.getCommentList(true)
    this.loginFlag = Boolean(sessionStorage.getItem('qs_token'))
  },
  methods: {
    openQue () {
      // 小智问答
      this.id = 0
      this.jimpId = 0
      this.dataList = []
      this.jiazai = true
      this.showFourList = false
      this.showFourListA = false
      this.showFourListB = false
      this.showFourListSe = false
      this.showFourListDQ = false
      this.showFourListJC = false
      this.showAllFileList = false
      this.showQueXZ = false
      this.inputValA = ''
      this.startLoading()
      api.cdAshKetchupModelList({
        phone: sessionStorage.getItem('qs_phone') || ''
        // id: 1
      }).then(res => {
        this.optBtnName = res.data.btnName
        this.isShow = res.data.isShow
        this.switchList = res.data.list
        this.modelList = res.data.list
        this.activeModelItem = this.modelList[0]
        // this.fileCategoryList = res.data.fileCategoryList
        this.fileCategoryList = ['环评', '监测', '工程']
        this.fileCategory = this.fileCategoryList[0]
        this.listTen = res.data.listTen ? res.data.listTen : []
        this.aiName = res.data.listTen ? res.data.listTen[0] : ''
        this.modelName = res.data.modelName
        api.cdAshKetchupDialogue({
          phone: sessionStorage.getItem('qs_phone') || '',
          needCitation: 1
          // typeTen: this.activeModelItem.value,
          // fileCategory: this.fileCategory
          // id: 1
        }).then(res1 => {
          this.showLoadingSteps = false
          this.loadingTips = '完成'
          if (res1.code === 200) {
            this.numberQA = res1.data.number
            // this.dataList = this.dataList.concat(res1.data)
            this.dataList.push(res1.data)
            console.log('numberQA', this.numberQA)
            this.scrollToBottom()
          } else {
            this.errorObj.list0[0].list[0].question = res1.message ? res1.message : this.errorTips
            this.dataList.push(JSON.parse(JSON.stringify(this.errorObj)))
            this.scrollToBottom()
          }
        })
      })
      this.showQueList = true
      this.showChatAuto = true
    },
    seeName (name) {
      this.nameNum = name
    },
    receiveName () {
      this.handleCommonItemClick(this.searchQ)
    },
    doComment () {
      if (!this.loginFlag) {
        this.loginDialogShow = true
        return
      }
      if (!this.commentValue) {
        this.$toast.text('请输入评论内容！')
        return
      }
      api.publicComment({
        postId: this.$route.query.id,
        comment: xss(this.commentValue)
      }).then(res => {
        if (res.code === 200) {
          this.loading && this.loading.hide()
          this.focusFlag = false
          this.$toast.text(res.message || '评论成功', {
            duration: 1200
          })
        }
      })
    },
    deleteComment (id) {
      api.deletePublicComment({
        commentId: id
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.text('删除成功')
          this.getCommentList(true)
        }
      })
    },
    getCommentList (refresh) {
      if (refresh) {
        this.pageNo = 1
        this.commentList = []
        this.pageEnd = false
      }
      this.isLoading = true
      api.getPublicComments({
        pages: 20,
        pageNo: this.pageNo,
        postId: this.$route.query.id || 1
      }).then(res => {
        this.isLoading = false
        if (res.code === 200) {
          this.pageNo++
          this.commentList = [...this.commentList, ...res.data.list]
          this.pageEnd = (this.commentList.length >= res.data.totalNumber) || (this.pageNo === 3)
        }
      })
    },
    async openPDF (name, link, id) {
      // if (!await this.gotoLogin()) return
      if (/chm/ig.test(link)) {
        this.alert = this.$alert('.chm文件，打开时系统会有安全警告弹窗，将弹窗提示中的「打开此文件前总是询问」取消勾选状态，下次便可通过环保小智直接打开了。否则会出现空白状态！', '关于.chm文件的重要提示！', {
          confirmButtonText: '确定',
          callback: action => {
            this.doCount(name, link, id)
          }
        })
      } else {
        this.doCount(name, link, id)
      }
    },
    doCount (name, link, id) {
      // this.loading = this.$loading({
      //   lock: true,
      //   text: '加载中…，按下ESC可退出加载',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      // this.$refs.fileHistoryRef.addFileHistoryList({ name, link, id })
      var checkType = 0
      if (this.componentName === 'file') {
        checkType = 0
      } else if (this.componentName === 'report') {
        checkType = 1
      } else if (this.componentName === 'other') {
        checkType = 2
      }
      api.openFileLimitCheck({
        fileId: id,
        type: checkType
      }).then(resCheck => {
        if (resCheck.code === 200) {
          window.open(link)
        }
      })
    },
    handleCommonItemClick (item) {
      this.showChatAuto = false
      this.showAllFileList = false
      this.showQueXZ = true
      api.getUserInfo().then(resUI => {
        if (resUI.code === 200) {
          this.searchQ = item
          let tmpQ = item
          tmpQ.match(/[A-Za-z]+/g) && tmpQ.match(/[A-Za-z]+/g).forEach(val => {
            tmpQ = tmpQ.replace(val, val + ' ')
          })
          tmpQ.match(/\d+/g) && tmpQ.match(/\d+/g).forEach(val => {
            tmpQ = tmpQ.replace(val, val + ' ')
          })
          tmpQ = tmpQ.replace(/-|\/|\\|'|"|’|‘|”|“|【|】|[|]|{|}/ig, ' ')
          this.childSearchQ = {
            q: tmpQ,
            tmp: new Date().getTime()
          }
        } else {
          // this.loginDialogShow = true
          this.$refs.pTLO.doLogin()
        }
      })
    },
    afterPDFOpen () {
      this.loading && this.loading.close()
      this.percent = 0
    },
    // 小智问答
    openShow (itemA, item) {
      if (itemA.id === 122) {
        item.isShowMoreFile = !item.isShowMoreFile
        console.log('isShowMoreFile', item.isShowMoreFile)
        return
      }
      this.ansNew = 'wjzl'
      this.showFourList = false
      this.showFourListA = false
      this.showFourListB = false
      this.showFourListSe = false
      this.showFourListDQ = false
      this.showFourListJC = false
      this.showAllFileList = false
      this.showFileAllList = false
      item.userAnswer = itemA.question
      item.userAns = true
      this.startLoading()
      // api.cdAshKetchupEnquiryOne({
      // api.cdAshKetchupAnswerId({
      // number: this.numberQA,
      // id: itemA.id
      // }).then(res => {
      console.log('111', itemA.answerId)
      this.showLoadingSteps = false
      this.loadingTips = '完成'
      // this.dataList = this.dataList.concat(res.data)
      this.jimpId = itemA.id
      console.log('fdsfds', this.inputValA)
      if (itemA.id === 108) {
        this.showFourList = false
        this.showFourListA = false
        this.showFourListB = false
        this.showFourListSe = false
        this.showFourListDQ = false
        this.showFourListJC = false
        this.showAllFileList = false
        this.showFileAllList = false
        setTimeout(() => {
          this.showFourList = true
        }, 1000)
      } else if (itemA.id === 109) {
        this.showFourList = false
        this.showFourListA = false
        this.showFourListB = false
        this.showFourListSe = false
        this.showFourListDQ = false
        this.showFourListJC = false
        this.showAllFileList = false
        this.showFileAllList = false
        setTimeout(() => {
          this.showFourListA = true
        }, 1000)
      } else if (itemA.id === 110 || itemA.id === 111) {
        this.showFourList = false
        this.showFourListA = false
        this.showFourListB = false
        this.showFourListSe = false
        this.showFourListDQ = false
        this.showFourListJC = false
        this.showAllFileList = false
        this.showFileAllList = false
        api.getSuggest({
          classaOne: itemA.id,
          pro: '',
          sort: 0,
          name: this.inputValA,
          pages: 10,
          pageNo: 1,
          classa: ''
        }).then(res => {
          this.fileList = res.data.list
          this.totalNumber = res.data.totalNumber
        })
        setTimeout(() => {
          this.showFourListB = true
        }, 1000)
      } else if (itemA.id === 113) {
        this.showFourList = false
        this.showFourListA = false
        this.showFourListB = false
        this.showFourListSe = true
        this.showFourListDQ = false
        this.showFourListJC = false
        this.showAllFileList = false
        this.showFileAllList = false
        setTimeout(() => {
          this.showFourListSe = true
        }, 1000)
      } else if (itemA.id === 114) {
        this.showFourList = false
        this.showFourListA = false
        this.showFourListB = false
        this.showFourListSe = false
        this.showFourListDQ = false
        this.showFourListJC = false
        this.showAllFileList = false
        this.showFileAllList = false
        setTimeout(() => {
          this.showFourListDQ = true
        }, 1000)
      } else if (itemA.id === 119) {
        this.showFourList = false
        this.showFourListA = false
        this.showFourListB = false
        this.showFourListSe = false
        this.showFourListDQ = false
        this.showFourListJC = false
        this.showAllFileList = false
        this.showFileAllList = false
        setTimeout(() => {
          this.showFourListJC = true
        }, 1000)
      } else if (itemA.id === 120) {
        // 返消息
        // this.dataList = this.dataList.concat(res.data)
      } else if (itemA.id === 2) {
        // this.searchQ = this.inputValA
        let tmpQ = this.inputValA
        tmpQ.match(/[A-Za-z]+/g) && tmpQ.match(/[A-Za-z]+/g).forEach(val => {
          tmpQ = tmpQ.replace(val, val + ' ')
        })
        tmpQ.match(/\d+/g) && tmpQ.match(/\d+/g).forEach(val => {
          tmpQ = tmpQ.replace(val, val + ' ')
        })
        tmpQ = tmpQ.replace(/-|\/|\\|'|"|’|‘|”|“|【|】|[|]|{|}/ig, ' ')
        this.showFourList = false
        this.showFourListA = false
        this.showFourListB = false
        this.showFourListSe = false
        this.showFourListDQ = false
        this.showFourListJC = false
        this.showAllFileList = false
        this.showFileAllList = false
        setTimeout(() => {
          this.showAllFileList = true
          this.childSearchQ1 = {}
          this.childSearchQ2 = {}
          this.$nextTick(() => {
            this.childSearchQ1 = {
              q: tmpQ,
              idSeach: 0,
              p: '精确搜索',
              srcType: 0,
              tmp: new Date().getTime()
            }
            this.childSearchQ2 = {
              q: tmpQ,
              idSeach: 0,
              p: '精确搜索',
              srcType: 0,
              tmp: new Date().getTime()
            }
          })
        }, 1000)
      } else {
        this.startLoading()
        // api.cdAshKetchupEnquiryOne({
        // api.cdAshKetchupAnswerId({
        // number: this.numberQA,
        // id: itemA.id
        // }).then(resB => {
        var aux = document.createElement('input')
        aux.setAttribute('value', `https://gongshi.qsyhbgj.com/chatAutoAnswer?answerId=${itemA.answerId}`)
        document.body.appendChild(aux)
        aux.select()
        document.execCommand('copy')
        document.body.removeChild(aux)
        var remarks240BConfirm = confirm('已复制到剪切板，可自行分享哦！')
        if (remarks240BConfirm) {}
        console.log('222', itemA.answerId)
        this.showLoadingSteps = false
        this.loadingTips = '完成'
        // })
      }
      // })
    },
    // 智能搜索
    openSrcFile (item) {
      if (Number(item.srcType) === 6) {
        window.open(item.url)
      } else {
        this.ansNew = 'znwd'
        console.log('item', item)
        this.srcType = Number(item.srcType)
        if (Number(item.srcType) === 0) {
          this.componentName = 'file'
          this.componentName = 'file'
        } else if (Number(item.srcType) === 1) {
          this.componentName = 'report'
          this.componentName = 'report'
        } else if (Number(item.srcType) === 3 || Number(item.srcType) === 2) {
          this.componentName = 'ask'
          this.componentName = 'ask'
        } else if (Number(item.srcType) === 5) {
          this.componentName = 'other'
          this.componentName = 'other'
        }
        let tmpQ = this.inputValA
        tmpQ.match(/[A-Za-z]+/g) && tmpQ.match(/[A-Za-z]+/g).forEach(val => {
          tmpQ = tmpQ.replace(val, val + ' ')
        })
        tmpQ.match(/\d+/g) && tmpQ.match(/\d+/g).forEach(val => {
          tmpQ = tmpQ.replace(val, val + ' ')
        })
        tmpQ = tmpQ.replace(/-|\/|\\|'|"|’|‘|”|“|【|】|[|]|{|}/ig, ' ')
        this.showFourList = false
        this.showFourListA = false
        this.showFourListB = false
        this.showFourListSe = false
        this.showFourListDQ = false
        this.showFourListJC = false
        this.showAllFileList = false
        this.showQueXZ = false
        this.showFileAllList = false
        setTimeout(() => {
          this.showQueXZ = false
          this.showAllFileList = true
          this.childSearchQ1 = {}
          this.childSearchQ2 = {}
          this.$nextTick(() => {
            this.childSearchQ = {
              q: tmpQ,
              idSeach: item.srcId,
              p: '精确搜索',
              srcType: Number(item.srcType),
              tmp: new Date().getTime()
            }
            // this.childSearchQ2 = {
            //   q: tmpQ,
            //   idSeach: item.srcId,
            //   p: '精确搜索',
            //   srcType: Number(item.srcType),
            //   tmp: new Date().getTime()
            // }
          })
        }, 1000)
      }
    },
    openShowA (inputValA, item) {
      console.log('inputValA', inputValA)
      // if (this.payTipsType === '不提示') {
      // }
      this.inputValAa = inputValA
      this.itemAa = item
      if (this.payTipsType === '需提示') {
        this.payTipsFlag = true
      } else {
        if (!inputValA) {
          this.$toast.text('请输入您要提问的内容再点击发送哦！')
        } else {
          this.dataList.push({
            type: 'answer',
            userAnswer: JSON.parse(JSON.stringify(inputValA))
          })
          this.scrollToBottom()
          console.log('openShowA dataList', this.dataList)
          this.showAllFileList = false
          item.userAnswer = inputValA
          item.userAns = true
          if (this.jimpId === 8) {
            this.showFourList = false
            this.showFourListA = false
            this.showFourListB = false
            this.showFourListSe = false
            this.showFourListDQ = false
            this.showFourListJC = false
            this.showAllFileList = false
            this.showFileAllList = false
            setTimeout(() => {
              this.showFourList = true
            }, 1000)
          } else if (this.jimpId === 2) {
            // this.searchQ = inputValA
            let tmpQ = inputValA
            tmpQ.match(/[A-Za-z]+/g) && tmpQ.match(/[A-Za-z]+/g).forEach(val => {
              tmpQ = tmpQ.replace(val, val + ' ')
            })
            tmpQ.match(/\d+/g) && tmpQ.match(/\d+/g).forEach(val => {
              tmpQ = tmpQ.replace(val, val + ' ')
            })
            tmpQ = tmpQ.replace(/-|\/|\\|'|"|’|‘|”|“|【|】|[|]|{|}/ig, ' ')
            this.childSearchQ1 = {
              q: tmpQ,
              p: '精确搜索',
              tmp: new Date().getTime()
            }
            this.childSearchQ2 = {
              q: tmpQ,
              p: '精确搜索',
              tmp: new Date().getTime()
            }
            this.showFourList = false
            this.showFourListA = false
            this.showFourListB = false
            this.showFourListSe = false
            this.showFourListDQ = false
            this.showFourListJC = false
            this.showAllFileList = false
            this.showFileAllList = false
            setTimeout(() => {
              this.showAllFileList = true
            }, 1000)
          } else if (this.jimpId === 9) {
            this.showFourList = false
            this.showFourListA = false
            this.showFourListB = false
            this.showFourListSe = false
            this.showFourListDQ = false
            this.showFourListJC = false
            this.showAllFileList = false
            this.showFileAllList = false
            setTimeout(() => {
              this.showFourListA = true
            }, 1000)
          } else if (this.jimpId === 10 || this.jimpId === 11) {
            this.showFourList = false
            this.showFourListA = false
            this.showFourListB = false
            this.showFourListSe = false
            this.showFourListDQ = false
            this.showFourListJC = false
            this.showAllFileList = false
            this.showFileAllList = false
            api.getSuggest({
              classaOne: this.jimpId,
              pro: '',
              sort: 0,
              name: inputValA,
              pages: 10,
              pageNo: 1,
              classa: ''
            }).then(res => {
              this.fileList = res.data.list
              this.totalNumber = res.data.totalNumber
            })
            setTimeout(() => {
              this.showFourListB = true
            }, 1000)
          } else if (this.jimpId === 13) {
            this.showFourList = false
            this.showFourListA = false
            this.showFourListB = false
            this.showFourListSe = true
            this.showFourListDQ = false
            this.showFourListJC = false
            this.showAllFileList = false
            this.showFileAllList = false
            setTimeout(() => {
              this.showFourListSe = true
            }, 1000)
          } else if (this.jimpId === 14) {
            this.showFourList = false
            this.showFourListA = false
            this.showFourListB = false
            this.showFourListSe = false
            this.showFourListDQ = false
            this.showFourListJC = false
            this.showAllFileList = false
            this.showFileAllList = false
            setTimeout(() => {
              this.showFourListDQ = true
            }, 1000)
          } else if (this.jimpId === 19) {
            this.showFourList = false
            this.showFourListA = false
            this.showFourListB = false
            this.showFourListSe = false
            this.showFourListDQ = false
            this.showFourListJC = false
            this.showAllFileList = false
            this.showFileAllList = false
            setTimeout(() => {
              this.showFourListJC = true
            }, 1000)
          } else {
            this.startLoading()
            // api.cdAshKetchupEnquiryOne({
            this.param = {
              needCitation: 1,
              content: this.inputValA,
              typeOption: this.aiName
            }
            this.switchList.forEach((item, index) => {
              this.param[item.value] = item.active
            })
            console.log('switchList1', this.switchList, this.param)
            api.cdAshKetchupDialogue(this.param).then(res => {
              this.showLoadingSteps = false
              this.loadingTips = '完成'
              if (res.code === 200) {
                this.inputValA = res.data.searchWord ? res.data.searchWord : this.inputValA
                res.data.isShowMoreFile = false
                res.data.fileNum = 0
                res.data.list0.forEach((i0, idx0) => {
                  if (i0.type === 5) {
                    res.data.fileNum = i0.list.length
                  }
                })
                console.log('cdAshKetchupEnquiryOne', res.data)
                // this.dataList = this.dataList.concat(res.data)
                this.dataList.push(res.data)
                console.log('dataList', this.dataList)
                this.scrollToBottom()
              } else {
                this.errorObj.list0[0].list[0].question = res.message ? res.message : this.errorTips
                this.dataList.push(JSON.parse(JSON.stringify(this.errorObj)))
                this.scrollToBottom()
              }
            })
          }
        }
      }
    },
    changeSwitch (item, index) {
      if (item.isPay === 0) {
        this.payTipsFlag = false
        this.valueIndex = index
        this.switchList[index].active = this.switchList[index].active === 0 ? 1 : 0
      } else {
        this.payTips = item.payTips
        if (this.switchList[index].active === 0) {
          this.payTipsFlag = true
        } else {
          this.switchList[index].active = this.switchList[index].active === 0 ? 1 : 0
        }
        this.valueIndex = index
      }
    },
    changePayTips () {
      this.payTipsType = '需提示'
    },
    onCancelBtn () {
      this.payTipsFlag = false
    },
    onOkBtn () {
      console.log('2222', this.param)
      if (this.switchList[this.valueIndex].active === 0) {
        this.switchList[this.valueIndex].active = this.switchList[this.valueIndex].active === 0 ? 1 : 0
      }
      console.log('switchList2', this.switchList, this.param)
      // this.payTipsType = '不提示'
      this.payTipsFlag = false
      // this.openShowA(this.inputValAa, this.itemAa)
    },
    openAllMore () {
      this.showFileAllList = true
    },
    openOther (item) {
      api.cdAshFileAdd({
        keyword: item.keyword,
        fileId: item.id,
        phone: this.phone
      }).then(res => {
        console.log(res)
      })
      window.open(item.url)
      // ipcRenderer.send('ipcDownloadBegin', item.url)
    },
    handleCurrentChange (currentPage) {
      api.getSuggest({
        pro: '',
        sort: 0,
        name: this.inputValA,
        pages: 10,
        pageNo: currentPage,
        classa: ''
      }).then(res => {
        this.fileList = res.data.list
        this.totalNumber = res.data.totalNumber
      })
    },
    startLoading () {
      this.showLoadingSteps = true
      var t1Limit = 11
      var t1n = 5 * 1000
      var t1r = Math.random() * 10 * 1000
      var t2Limit = 61
      var t2n = 45 * 1000
      var t2r = Math.random() * 30 * 1000
      // text
      this.loadingTips = '问题分析中……'
      setTimeout(() => {
        this.loadingTips = '资料查找中……'
        setTimeout(() => {
          this.loadingTips = '回答整理中……'
        }, t2n + t2r)
      }, t1n + t1r)
      // progress
      this.loadingProgress = 0
      var startLoading1 = () => {
        var loadingInterval1 = setInterval(() => {
          this.loadingProgress = this.loadingProgress + 1
          if (this.loadingProgress >= t1Limit || !this.showLoadingSteps) {
            clearInterval(loadingInterval1)
            if (this.showLoadingSteps) {
              startLoading2()
            }
          }
        }, (t1n + t1r) / t1Limit)
      }
      var startLoading2 = () => {
        var loadingInterval2 = setInterval(() => {
          this.loadingProgress = this.loadingProgress + 1
          if (this.loadingProgress >= t2Limit || !this.showLoadingSteps) {
            clearInterval(loadingInterval2)
            if (this.showLoadingSteps) {
              startLoading3()
            }
          }
        }, (t2n + t2r) / (t2Limit - t1Limit))
      }
      var startLoading3 = () => {
        var loadingInterval3 = setInterval(() => {
          this.loadingProgress = this.loadingProgress + 1
          if (this.loadingProgress >= 99 || !this.showLoadingSteps) {
            clearInterval(loadingInterval3)
          }
        }, 2500)
      }
      startLoading1()
    },
    // 知识库上传文件
    showCompanyOption () {
      api.getUserInfo().then(res => {
        if (res.code === 200) {
          this.fileFlag = true
        }
      })
    },
    handleSuccess () {
      this.$toast.text('上传成功')
    },
    checkUpload () {
      this.$refs.uploadRef.doUpload()
    },
    closeIF () {
      this.fileFlag = false
    },
    showCompanyOptionA () {
      this.fileFlagA = true
    },
    handleSuccessA (fileParam) {
      this.fileFlagA = false
      console.log('fileParam', fileParam)
      this.dataList.push({
        type: 'answer',
        userAnswer: JSON.parse(JSON.stringify(fileParam.fileName))
      })
      this.scrollToBottom()
      this.showAllFileList = false
      this.startLoading()
      this.param = {
        needCitation: 1,
        content: fileParam.fileName,
        url: fileParam.url,
        fileId: fileParam.fileId,
        typeOption: this.aiName,
        documentChoose: '检查初审',
        dialogueSelection: '多轮'
      }
      this.switchList.forEach((item, index) => {
        this.param[item.value] = item.active
      })
      api.cdAshKetchupDialogue(this.param).then(res => {
        this.showLoadingSteps = false
        this.loadingTips = '完成'
        if (res.code === 200) {
          this.inputValA = res.data.searchWord ? res.data.searchWord : this.inputValA
          res.data.isShowMoreFile = false
          res.data.fileNum = 0
          res.data.list0.forEach((i0, idx0) => {
            if (i0.type === 5) {
              res.data.fileNum = i0.list.length
            }
          })
          console.log('cdAshKetchupEnquiryOne', res.data)
          // this.dataList = this.dataList.concat(res.data)
          this.dataList.push(res.data)
          this.scrollToBottom()
        } else {
          this.errorObj.list0[0].list[0].question = res.message ? res.message : this.errorTips
          this.dataList.push(JSON.parse(JSON.stringify(this.errorObj)))
          this.scrollToBottom()
        }
      })
      this.$toast.text('上传成功')
    },
    checkUploadA () {
      this.$refs.uploadRef.doUpload()
    },
    closeIFA () {
      this.fileFlagA = false
    },
    scrollToBottom () {
      setTimeout(() => {
        var linkId = document.querySelector('#bottomId')
        var bridge = linkId
        var body = document.body
        var height = 0
        do {
          height += bridge.offsetTop
          bridge = bridge.offsetParent
        } while (bridge !== body)
        // 滚动到指定位置
        window.scrollTo({
          top: height * 2,
          behavior: 'smooth'
        })
      }, 100)
    }
  },
  components: {
    accountCom,
    // banner,
    splitNewFiles,
    fileRank,
    // pcTitle,
    File,
    Report,
    Ask,
    Other,
    // SearchTips,
    PcTitleLogOnly,
    upFile,
    upFileA
  }
}
</script>

<style lang="scss">
.public-page {
  // padding-bottom: 58px;
  position: relative;
  .index-bottom-1 {
    position: fixed;
    left: 115%;
    top: 85%;
    width: 2810px;
    margin-left: -155%;
    background: #f2f6fc;
    text-align: left;
    font-size: 14px;
    padding: 10px;
    margin-top: 12px;
    .title-link {
      padding: 0 24px;
      padding-bottom: 8px;
      width: 700px;
      margin: 0 auto;
      font-size: 13px;
      .link-line {
        width: 1200px;
        .link-title {
          font-size: 16px;
          // color: #83889a;
          color: #000;
        }
        a {
          font-size: 14px;
          margin-right: 8px;
          color: #409EFF;
        }
      }
      .link-line-1 {
        width: 1200px;
        padding: 10px 0;
        a {
          font-size: 14px;
          margin-right: 8px;
          color: #551A8B;
        }
      }
    }
  }
  .public-back {
    transform: translateY(100%);
    text-decoration: underline;
    padding: 4px 12px;
    cursor: pointer;
    // position: fixed;
    top: 0;
    &:hover {
      color: #409EFF;
    }
    i {
      font-weight: bold;
    }
  }
  .search-main {
    transform: translateY(10%);
    padding: 0 12px 12px;
    margin-top: -12px;
    .search-list {
      margin-top: -54px;
      // margin: 0!important;
      padding: 0!important;
      .file-filter{
        padding: 0;
      }
    }
  }
  .doc-comment {
    background: #f4f5f6;
    .comment-title {
      padding: 2px 12px;
      display: flex;
      justify-content: space-between;
      .comment-more {
        color: #409EFF;
      }
    }
    .new-comment {
      border-bottom: 1px solid #efefef;
      padding: 2px 12px;
      color: #333;
      .comment-main {
        flex: 1;
        display: flex;
        .avator {
          width: 28px;
          height: 28px;
          border-radius: 100px;
          border: 1px solid #efefef;
          margin-right: 12px;
          flex: 0 0 28px;
        }
        .main-right {
          display: flex;
          flex-direction: column;
          .line {
            display: flex;
            align-items: center;
            .name {
              font-size: 14px;
              margin-right: 4px;
            }
            .time {
              color: #83889a;
            }
            .uni-icon {
              color: #28354c;
              margin-left: 8px;
              font-weight: 500;
            }
          }
          .content {
            .reply {
              padding: 0 8px;
              display: flex;
              flex-direction: column;
              .title {
                color: #83889a;
              }
            }
          }
        }
      }
    }
    .comment-empty {
      text-align: center;
      color: rgb(119, 119, 119);
    }
  }
  .bottom-wrap {
    position: fixed;
    bottom: 6px;
    left: 50%;
    width: 7.3rem;
    transform: translate(-50%);
    .bottom-main {
      display: flex;
      background: #fff;
      align-items: center;
      width: 7.3rem;
      margin: 0 auto;
      padding: 8px 12px;
      border-radius: 8px;
      box-shadow: 0px 2px 4px #ccc;
      .share {
        display: flex;
        flex-direction: column;
        margin-right: 12px;
        .text {
          line-height: 1;
          margin-top: 2px;
          font-size: 12px;
        }
      }
      .comment-input {
        // padding: 8px 0;
        height: 36px;
        line-height: 36px;
        flex: 1 0 25%;
        position: relative;
        .input-comment {
          input {
            height: 44px;
          }
        }
        img {
          position: absolute;
          right: 4px;
          top: 50%;
          transform: translateY(-50%);
          width: 28px;
        }
      }
      .big-button {
        flex: 0 0 80px;
        margin-left: 24px;
        display: flex;
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        .rules, .apply {
          flex: 1;
          text-align: center;
          line-height: 36px;
          height: 36px;
          color: #fff;
          &.gray {
            color: #fff;
            background: #666;
          }
        }
        .rules {
          background: linear-gradient(70deg,#eb934c,#d67946);
        }
        .apply {
          background: linear-gradient(70deg,#376dd6,#1b50b6);
        }
      }
      .cancel {
        margin-left: 12px;
      }
    }
  }
  .editor-wrap {
    // height: 520px;
    // padding: 12px;
    margin: 12px 12px 100px 12px;
    a {
      padding: 0 4px;
      img {
        width:18px;
        height:18px;
        vertical-align: text-bottom;
      }
    }
  }
  .home-banner {
    position: absolute;
    left: calc((100vw - 7.5rem) / 2 - 10px);
    top: 152px;
    transform: translateX(-100%);
    width: 300px;
    height: 56px; // 120
    position: fixed;
  }
  .searchdiv {
    position: absolute;
    left: calc((100vw - 7.5rem) / 2 - 10px);
    top: 2px;
    transform: translateX(-100%);
    width: 300px;
    height: 56px; // 120
    position: fixed;
    .search-tips{
      margin-top: -10px;
    }
    .do-public1 {
      display: block;
      // margin-left: 138px;
      // background: #409EFF;
      // color: #fff;
      // width: 70px;
      // width: 300px!important;
      line-height: 32px;
      text-align: center;
      border: #ccc solid 1px;
      border-radius: 4px;
      // padding: 0px 6px;
      margin-top: 4px;
      font-size: 16px;
      background-color: #409EFF;
      color: #fff;
      cursor: pointer;
    }
  }
  .home-split-newfiles {
    position: fixed;
    left: calc((100vw - 7.5rem) / 2 - 10px);
    // top: calc(160px + 32px); // 282
    top: calc(20px + 32px); // 282
    transform: translateX(-100%);
    width: 300px;
    height: 287px;
  }
  .file-rank-com {
    position: fixed;
    left: calc((100vw - 7.5rem) / 2 + 7.5rem + 10px);
    top: 16px;
    width: 300px;
    height: 287px;
    // height: 200px;
  }
  .w-e-text ul {
    list-style-type: disc;
  }
  .w-e-text ol {
    list-style-type: decimal;
  }
  .w-e-toolbar,
  .w-e-text-container,
  .w-e-menu-panel {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      background-color: #fff;
      /*表情菜单样式*/
      .eleImg{
          cursor: pointer;
          display: inline-block;
          font-size: 18px;
          padding: 0 3px;
      }
      * {
          padding: 0;
          margin: 0;
          box-sizing: border-box;
      }
      /*分割线样式*/
      hr{
        cursor: pointer;
        display: block;
        height: 0px;
        border: 0;
        border-top: 3px solid #ccc;
        margin: 20px 0;
      }
  }

  .w-e-clear-fix:after {
      content: "";
      display: table;
      clear: both;
  }

  .w-e-drop-list-item {
      position: relative;
      top: 1px;
      padding-right: 7px;
      color: #333 !important;
  }

  .w-e-drop-list-tl {
      padding-left: 10px;
      text-align: left;
  }

  .w-e-text-container {
      position: relative;

      .w-e-progress {
          position: absolute;
          background-color: #1e88e5;
          top: 0;
          left: 0;
          height: 1px;
      }

      .placeholder {
          color: #D4D4D4;
          position: absolute;
          font-size: 11pt;
          line-height: 22px;
          left: 10px;
          top: 10px;
          user-select: none;
          z-index: -1;
      }
  }
  .w-e-text {
      padding: 0 10px;
      overflow-y: auto;

      p,h1,h2,h3,h4,h5,table,pre {
          margin: 10px 0;
          line-height: 1.5;
      }

      ul, ol {
          margin: 10px 0 10px 20px;
      }

      blockquote {
          display: block;
          border-left: 8px solid #d0e5f2;
          padding: 5px 10px;
          margin: 10px 0;
          line-height: 1.4;
          font-size: 100%;
          background-color: #f1f1f1;
      }

      code {
          display: inline-block;
          background-color: #f1f1f1;
          border-radius: 3px;
          padding: 3px 5px;
          margin: 0 3px;
      }

      pre {

          code {
              display: block;
          }
      }

      table {
          border-top: 1px solid #ccc;
          border-left: 1px solid #ccc;

          td,th {
              border-bottom: 1px solid #ccc;
              border-right: 1px solid #ccc;
              padding: 3px 5px;
              min-height: 30px;
          }

          th {
              border-bottom: 2px solid #ccc;
              text-align: center;
              background-color: #f1f1f1;
          }
      }

      &:focus {
          outline: none;
      }

      img {
          cursor: pointer;

          &:hover {
              box-shadow: 0 0 5px #333;
          }
      }
  }

  .w-e-tooltip {
      position: absolute;
      display: flex;
      color: #f1f1f1;
      background-color: rgba(0,0,0,.75);
      box-shadow: 0 2px 8px 0 rgba(0,0,0,.15);
      border-radius: 4px;
      padding: 4px 5px 6px;
      position: absolute;
  }
  // 下箭头
  .w-e-tooltip-up::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border: 5px solid rgba(0,0,0,0);
      border-top-color: rgba(0,0,0,.73);
  }
  // 上箭头
  .w-e-tooltip-down::after {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border: 5px solid rgba(0,0,0,0);
      border-bottom-color: rgba(0,0,0,.73);
  }
  .w-e-tooltip-item-wrapper {
      cursor: pointer;
      font-size: 14px;
      margin: 0 5px;

      &:hover {
          color: #ccc;
          text-decoration: underline;
      }
  }
  .search-chat-detail-auto {
    // border-right: 1px #f4f5f6 solid;
    // padding: 10px;
    // width: calc(100% - 250px);
    width: 100%;
    // width: 70%;
    // max-width: calc(100% - 250px);
    // border-left: 1px #ccc solid;
    // background-color: #fff;
    // overflow: auto;
    height: 100%;
    overflow: auto;
    .message-item {
      // display: inline-block;
      border: 1px solid #efefef;
      border-radius: 0 12px 12px 12px;
      text-align: left;
      font-size: 16px;
      margin: 0 8px;
      width: fit-content;
      max-width: 80%;
      border: 1px #ccc solid;
      background-color: #fff;
      padding: 0 4px 0 4px;
      line-height: 24px;
      .message-file {
        color: #409eff;
      }
      .message-option {
        color: #409eff;
      }
      .message-option-null {
        color: #83889a;
      }
      .message-inline {
        color: #409eff;
      }
      .message-srcFile {
        color: #409eff;
        height: 24px;
        max-width: calc(100vw - (8px + 36px + 8px + 1px + 12px) * 2);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .message-srcFile-hide {
        display: none;
      }
    }
    .input-box {
      text-align: right;
      margin: 10px 0 0 0;
      .input-box-line {
        width: 100%;
        display: flex;
        .input-box-inner {
          height: 100px;
          text-align: left;
          width: 100%;
        }
        .input-box-inner-left {
          width: 40%;
          height: 100%;
        }
        .input-box-inner-right {
          width: 60%;
          height: 100%;
          overflow: hidden;
          padding: 0 8px 4px;
          .input-textarea {
            height: 60px!important;
            width: 100%!important;
            .el-textarea__inner {
              height: 60px!important;
              width: 100%!important;
              border-radius: 8px;
              border: #ccc solid 1px;
            }
          }
          .btn-line {
            display: flex;
            margin-bottom: 4px;
            height: 36px;
            width: calc(100% - 2 * 0px);
            margin: 4px 0px 0;
            .line-inner {
              display: flex;
              width: 100%;
            }
            .line-left {
              width: calc(100% - 72px);
              .btn {
                height: 26px;
                line-height: 24px;
                font-size: 14px;
                border-radius: 16px;
                padding: 3px 10px 1px;
                margin-right: 4px;
                color: #ccc;
                border: #ccc solid 1px;
              }
              .btn-active {
                color: #409eff;
                border: #409eff solid 1px;
                background-color: #dfefff;
              }
            }
            .line-right {
              width: 72px;
              // text-align: right;
              // justify-content: right;
              .btn {
                margin-left: 4px;
                height: 32px;
                width: 32px;
                font-size: 16px;
                line-height: 20px;
                padding: 6px;
                border: #ccc solid 1px;
              }
              .submit {
                padding: 7px 6px;
              }
            }
          }
        }
      }
    }
  }
  .nut-dialog-b .nut-dialog {
    // max-width: 520px;
    max-width: 500px;
  }
  .nut-dialog-a .nut-dialog {
    // max-width: 520px;
    max-width: 800px;
  }
  .nut-dialog-c .nut-dialog {
    // max-width: 520px;
    max-width: 450px;
  }
}
</style>
